/*import "./assets/css/App.css";*/

import "./assets/sass/main.scss";

import "./assets/css/Bpmn.icons.css";
import "./assets/css/Bg.icons.css";
import "./assets/css/material.min.css";

import "../node_modules/@syncfusion/ej2-icons/styles/material.css";

import { Provider } from "react-redux";
import store from "../src/redux/store";
import Route from "./Route";
import ThemeProvider from "./theme/ThemeProvider";

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <Provider store={store}>
          <Route />
        </Provider>
      </ThemeProvider>
    </div>
  );
}

export default App;
